import {WixSdk} from '@wix/js-sdk-wrapper';

const compId = WixSdk.Utils.getCompId() || 'standalone';

interface IDebugSettings {
  debugEnabled: boolean;
  skipFullSettings: boolean;
}

export let debugSettings: IDebugSettings = {debugEnabled: false, skipFullSettings: false};

export const start = async () => {
  const {DebugPanel, makePersistent, persistent, requiresReload, Storage, title} = await import('@wix/debug-panel');

  class DebugSettings implements IDebugSettings {
    @title('Debug Enabled')
    @persistent
    @requiresReload
    public debugEnabled: boolean = false;

    @title('Skip settings')
    @requiresReload
    @persistent
    public skipFullSettings: boolean = false;
  }
  debugSettings = makePersistent(new DebugSettings(), new Storage(`music-widget:${compId}`));

  const debugPanel = new DebugPanel(debugSettings, {
    showGeneralInfo: true,
    version: process.env.ARTIFACT_VERSION,
  });

  debugPanel.start();
};
